import script from "./AdminManageTableExpandColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManageTableExpandColumn.vue?vue&type=script&setup=true&lang=js"

import "./AdminManageTableExpandColumn.vue?vue&type=style&index=0&id=6ebcd286&scoped=true&lang=css"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebcd286"]])

export default __exports__